// extracted by mini-css-extract-plugin
export default {"sidenav-expander":"sidenav-expander_QkvPJ0rp"};